/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import Vuex from 'vuex'

import state from '@/store/state'
import getters from '@/store/getters'
import mutations from '@/store/mutations'
import actions from '@/store/actions'

Vue.use(Vuex)

import moduleAuth from './auth/'
import moduleUser from './user'
import modulePatient from './patient'
import moduleSupplier from './supplier'
import moduleRole from './role'
import moduleClient from './client'
import moduleTransporter from './transporters'
import moduleExpenseCategory from './expense-category'
import moduleExpense from './expense'
import moduleBatch from './batch'
import modulePermission from './permission'
import moduleInventroy from './inventory'
import moduleProduct from './product'
import moduleSetting from './setting'
import modulePos from './pos'
import moduleMarketplace from './marketplace'
import moduleLab from '@/store/lab'
import moduleLabTest from '@/store/lab-test' // lab test store
import moduleReports from './reports'
import moduleDashboard from '@/store/dashboard' // dashboard store
import moduleContactus from '@/store/contactus' // contact us store
import moduleStrain from '@/store/strain'
import moduleRegister from '@/store/register' // register store
import modulePunchClock from '@/store/punch-clock' // punch clock store
import moduleLocation from '@/store/location' // location store
import modulePromoDiscount from '@/store/promo-discount' // promo discount store
import moduleSeedsuiteTags from '@/store/tags'
import moduleDiscount from '@/store/discount'
import moduleTransfer from '@/store/transfer'

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: moduleAuth,
    user: moduleUser,
    patient: modulePatient,
    supplier: moduleSupplier,
    role: moduleRole,
    client: moduleClient,
    transporter: moduleTransporter,
    expense_category: moduleExpenseCategory,
    expense: moduleExpense,
    batch: moduleBatch,
    permission: modulePermission,
    inventory: moduleInventroy,
    product: moduleProduct,
    setting: moduleSetting,
    pos: modulePos,
    marketplace: moduleMarketplace,
    lab: moduleLab,
    lab_test: moduleLabTest,
    report: moduleReports,
    dashboard: moduleDashboard,
    contactus: moduleContactus,
    strain: moduleStrain,
    register: moduleRegister,
    punch_clock: modulePunchClock,
    location: moduleLocation,
    promo_discount: modulePromoDiscount,
    tags: moduleSeedsuiteTags,
    discount: moduleDiscount,
    transfer: moduleTransfer
  },
  strict: process.env.NODE_ENV !== 'production'
})
